import styled from 'styled-components';
import { motion } from 'framer-motion';

export const CardLayer = styled(motion.div)`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1;
  display: flex;
  flex-direction: column;

  pointer-events: none;
  & > * {
    pointer-events: all;
  }
`;
